import type { MatchWording } from '../../../../services/interfaces';

let matchWording: MatchWording;

export const setMatchWording = (wording: MatchWording) => {
  matchWording = { ...wording };
};

export const getMatchWording = (key: string): string => matchWording[key];
